import React from 'react';
import { styled } from '@compiled/react';
import ProgressBar from '@atlaskit/progress-bar';
import { token } from '@atlaskit/tokens';

const ProgressBarIndeterminate = () => (
	<Wrapper>
		<ProgressBar isIndeterminate />
	</Wrapper>
);

export default ProgressBarIndeterminate;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	width: '50%',
	margin: `${token('space.150', '12px')} auto 28px auto`,
});
